/* eslint-disable no-template-curly-in-string */
export enum ErrorMessage {
	REQUIRED = "formErrorMessages.required",
	EMAIL = "formErrorMessages.email",
	PHONE = "formErrorMessages.phone",
	SITE = "formErrorMessages.site",
	REQUIRED_FIELDS = "formErrorMessages.requiredFields",
	ANY_OPTION = "formErrorMessages.anyOptions",
	MIN = "formErrorMessages.min ${min}",
	DATE = "formErrorMessages.date",
	TIME = "formErrorMessages.time",
	MORE_THAN = "formErrorMessages.more ${more}",
	DATE_FUTURE = "formErrorMessages.dateFuture",
	TIME_FUTURE = "formErrorMessages.timeFuture",
	DATE_MORE = "formErrorMessages.dateMore ${more}",
	TIME_MORE = "formErrorMessages.timeMore ${more}",
}
